module.exports = __webpack_public_path__ + "static/media/unitedstates.0dfe8eb4.svg";